export default {
    role: {
        superadmin: 'Super Admin',
        admin: 'Admin',
        hr: 'HR'
    },
    attendance: {
        view: 'ATTENDANCE-VIEW',
        update: 'ATTENDANCE-UPDATE'
    },
    branch: {
        view: 'BRANCH-VIEW',
        create: 'BRANCH-CREATE',
        update: 'BRANCH-UPDATE',
        delete: 'BRANCH-DELETE'
    },
    company: {
        view: 'COMPANY-SETTING-VIEW',
        update: 'COMPANY-SETTING-UPDATE'
    },
    companyHoliday: {
        view: 'COMPANY-HOLIDAY-VIEW',
        create: 'COMPANY-HOLIDAY-CREATE',
        update: 'COMPANY-HOLIDAY-UPDATE',
        delete: 'COMPANY-HOLIDAY-DELETE'
    },
    groupHoliday: {
        view: 'GROUP-HOLIDAY-VIEW',
        create: 'GROUP-HOLIDAY-CREATE',
        update: 'GROUP-HOLIDAY-UPDATE',
        delete: 'GROUP-HOLIDAY-DELETE'
    },
    department: {
        view: 'DEPARTMENT-VIEW',
        create: 'DEPARTMENT-CREATE',
        update: 'DEPARTMENT-UPDATE',
        delete: 'DEPARTMENT-DELETE'
    },
    employee: {
        view: 'EMPLOYEE-VIEW',
        create: 'EMPLOYEE-CREATE',
        update: 'EMPLOYEE-UPDATE',
        delete: 'EMPLOYEE-DELETE'
    },
    groupWorkday: {
        view: 'GROUP-WORKDAY-VIEW',
        create: 'GROUP-WORKDAY-CREATE',
        update: 'GROUP-WORKDAY-UPDATE',
        delete: 'GROUP-WORKDAY-DELETE'
    },
    lineService: {
        update: 'LINE-SERVICE-UPDATE'
    },
    report: {
        view: 'REPORT-VIEW'
    },
    specialWorkday: {
        view: 'SPECIAL-WORKDAY-VIEW',
        create: 'SPECIAL-WORKDAY-CREATE',
        update: 'SPECIAL-WORKDAY-UPDATE',
        delete: 'SPECIAL-WORKDAY-DELETE'
    },
    userManagement: {
        superAdmin: {
            view: 'SUPER-ADMIN-USER-MANAGEMENT-VIEW'
        },
        admin: {
            view: 'ADMIN-USER-MANAGEMENT-VIEW',
            create: 'ADMIN-USER-MANAGEMENT-CREATE',
            update: 'ADMIN-USER-MANAGEMENT-UPDATE',
            delete: 'ADMIN-USER-MANAGEMENT-DELETE'
        },
        hr: {
            view: 'HR-USER-MANAGEMENT-VIEW',
            create: 'HR-USER-MANAGEMENT-CREATE',
            update: 'HR-USER-MANAGEMENT-UPDATE',
            delete: 'HR-USER-MANAGEMENT-DELETE'
        }
    },
    inquiry: {
        view: 'INQUIRY-VIEW',
        update: 'INQUIRY-UPDATE'
    },
    device: {
        view: 'DEVICE-VIEW',
        create: 'DEVICE-CREATE',
        update: 'DEVICE-UPDATE',
        delete: 'DEVICE-DELETE'
    },
    leaveQuota: {
        view: 'LEAVE-QUOTA-SETTING-VIEW',
        update: 'LEAVE-QUOTA-SETTING-UPDATE'
    },
    visitor: {
        view: 'VISITOR-VIEW',
        create: 'VISITOR-CREATE',
        update: 'VISITOR-UPDATE',
        delete: 'VISITOR-DELETE'
    },
    savePlace: {
        view: 'SAVE-PLACE-VIEW',
        create: 'SAVE-PLACE-CREATE',
        update: 'SAVE-PLACE-UPDATE',
        delete: 'SAVE-PLACE-DELETE'
    },
    blacklist: {
        view: 'BLACKLIST-VIEW',
        create: 'BLACKLIST-CREATE',
        update: 'BLACKLIST-UPDATE',
        delete: 'BLACKLIST-DELETE'
    },
    punchlog: {
        view: 'PUNCH-LOG-VIEW'
    }
}
